import { ServiceTitanWorkType } from "../updateBusinessUnitWorkTypes/types";

/**
 * ServiceTitan's number for the "Other" unit the sync auto-creates, which
 * stands in for the hidden and system-level units their API does not return.
 *
 * A bucket rather than a business unit: its jobs are a mix, so it cannot be
 * described as service or replacement work and the API refuses an attempt
 * (`CatchAllBusinessUnitWorkTypeException`, 400). Recognised by this number
 * and not by the name "Other", which is a string the sync writes and could
 * change without anything failing.
 */
export const CATCH_ALL_SERVICE_TITAN_ID = 0;

export interface BusinessUnit {
  id: number;
  uuid: string;
  /**
   * ServiceTitan's own id, which is what the rules about a unit are written
   * in. `id` above is hub's row id and identifies nothing on their side.
   */
  serviceTitanId: number;
  name: string;
  isImportEnabled: boolean;
  isLocked: boolean;
  /**
   * Service or replacement work, or null when nobody has decided. Independent
   * of `isLocked`, which governs the trade mapping only.
   */
  workType: ServiceTitanWorkType | null;
  createdAt: string;
  updatedAt: string;
}

export interface FetchBusinessUnitsResponse {
  data: {
    businessUnits: BusinessUnit[];
    total: number;
    companyId: number;
  };
}
